import { render } from "./TotalCost.vue?vue&type=template&id=62185fbb&scoped=true"
import script from "./TotalCost.vue?vue&type=script&lang=js"
export * from "./TotalCost.vue?vue&type=script&lang=js"

import "./TotalCost.vue?vue&type=style&index=0&id=62185fbb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62185fbb"]])

export default __exports__